import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import React from "react";
import {BrowserRouter, useHistory} from "react-router-dom";

import {jdBlack, ThemeProvider} from "@deere/fuel-react";
import {Box} from '@mui/material'
import { Helmet } from "react-helmet-async";
import { Provider } from "react-redux";
import "./App.css";
import { TPRoutes } from "./components/TPRoutes";
import store from "./store/store";

const HOST_NAME = window && window.location && window.location.hostname;

function App() {
  const pageMinHeight = "calc(100vh - 105px)";

  const oidcconfig = {
    clientId: getClientId(),
    issuer: getIssuer(),
    redirectUri: window.location.origin + "/implicit/callback",
    scopes: require("./utils/config/keys").scopes,
    pkce: true,
  };
  const oktaAuth = new OktaAuth(oidcconfig);
  const history = useHistory();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  const triggerLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  const customAuthHandler = async () => {
    const previousAuthState = oktaAuth.authStateManager.getPreviousAuthState();
    if (!previousAuthState || !previousAuthState.isAuthenticated) {
      await triggerLogin();
    } else {
      console.log("You need to re-authenticate");
    }
  };

  return (
      <BrowserRouter>
        <ThemeProvider theme={jdBlack} includeFonts={false}>
          <Security
              oktaAuth={oktaAuth}
              onAuthRequired={customAuthHandler}
              restoreOriginalUri={restoreOriginalUri}
          >
            <Box component="main" container sx={{ minHeight: pageMinHeight }}>
              <Provider store={store}>
                <TPRoutes />
              </Provider>
            </Box>
          </Security>
        </ThemeProvider>
      </BrowserRouter>
  );
}

export function getIssuer() {
  let issuerLOCAL = require("./utils/config/keys").issuerLOCAL;
  let issuerDEVL = require("./utils/config/keys").issuerDEVL;
  let issuerQUAL = require("./utils/config/keys").issuerQUAL;
  let issuerCERT = require("./utils/config/keys").issuerCERT;
  let issuerPROD = require("./utils/config/keys").issuerPROD;
  return HOST_NAME === require("./utils/config/keys").talHost
      ? issuerDEVL
      : HOST_NAME === require("./utils/config/keys").qualHost ||
      HOST_NAME === require("./utils/config/keys").qualHostTemp
          ? issuerQUAL
          : HOST_NAME === require("./utils/config/keys").ProdHost ||
          HOST_NAME === require("./utils/config/keys").ProdHostTemp
              ? issuerPROD
              : HOST_NAME === require("./utils/config/keys").certHost
                  ? issuerCERT
                  : issuerLOCAL;
}

export function getClientId() {
  let clientIdLOCAL = require("./utils/config/keys").clientLOCAL;
  let clientIdDEVL = require("./utils/config/keys").clientDEVL;
  let clientIdQUAL = require("./utils/config/keys").clientQUAL;
  let clientIdCERT = require("./utils/config/keys").clientCERT;
  let clientIdPROD = require("./utils/config/keys").clientPROD;
  return HOST_NAME === require("./utils/config/keys").talHost
      ? clientIdDEVL
      : HOST_NAME === require("./utils/config/keys").qualHost ||
      HOST_NAME === require("./utils/config/keys").qualHostTemp
          ? clientIdQUAL
          : HOST_NAME === require("./utils/config/keys").ProdHost ||
          HOST_NAME === require("./utils/config/keys").ProdHostTemp
              ? clientIdPROD
              : HOST_NAME === require("./utils/config/keys").certHost
                  ? clientIdCERT
                  : clientIdLOCAL;
}

export default App;
